// Shared, side-effect-free pricing helpers used by Rooms/RoomDetail and their
// sub-components. Kept pure so they're trivially unit-testable and reused
// verbatim by both list and detail views (no duplication).

// Industry-standard Booking.com commission markup (~18%). Hotels typically
// raise OTA rates by this much to net the same after commission.
export const BCOM_MARKUP = 0.18;

export const formatPrice = (price) => {
  if (price === null || price === undefined) return '—';
  return new Intl.NumberFormat('en-EU', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });

// A "pricing" object (from /api/beds24/availability) is only actionable when
// both a total and per-night rate are present.
export const isPriced = (pricing) =>
  pricing &&
  pricing.pricing &&
  pricing.pricing.total_price != null &&
  pricing.pricing.price_per_night != null;

export const getBookingComPrice = (direct) => {
  if (direct == null) return null;
  const raw = direct * (1 + BCOM_MARKUP);
  return Math.ceil(raw / 5) * 5; // round up to nearest €5
};

export const getSavingsVsBcom = (direct) => {
  if (direct == null) return 0;
  return getBookingComPrice(direct) - direct;
};
